import { fiscalService } from '../fiscal';
import { I18n } from '../wrappers/I18n';
import { AppStorageKey } from '../types';
import { appStorage } from '../utilities';
import Store from '../wrappers/Store';
import moment from 'moment-timezone';
export const CertificateService = {
    async getInfo(sdc) {
        let warningMsg = undefined;
        let expiresAt = undefined;
        let daysLeft = undefined;
        if (I18n.c('order.registerMethod') === 'mehr') {
            const tenant = Store.get('tenant');
            expiresAt = tenant?.cert_expire_at || undefined;
            if (expiresAt) {
                daysLeft = moment(expiresAt).diff(moment(), 'days');
                if (daysLeft < 0) {
                    warningMsg = I18n.t('general.certificate_expired', { value: moment(expiresAt).format('DD.MM.YYYY.') });
                }
                else if (daysLeft <= 30) {
                    warningMsg = I18n.t('general.certificate_expires', { value: moment(expiresAt).format('DD.MM.YYYY.') });
                }
            }
        }
        if (I18n.c('order.registerMethod') === 'taxcore') {
            const sdcType = fiscalService.getSdcType(sdc);
            if (sdcType === 'ESDC') {
                expiresAt = (await appStorage.native().getItem(AppStorageKey.esdcCertExpirationDate)) || undefined;
                if (!expiresAt) {
                    const uiData = (await fiscalService.getUiData('ESDC'))?.data;
                    expiresAt = uiData?.certExpDate || undefined;
                }
                if (expiresAt) {
                    daysLeft = moment(expiresAt).diff(moment(), 'days');
                    if (daysLeft < 0) {
                        warningMsg = I18n.t('sdc.esdc.certificate_expired_message', { value: moment(expiresAt).format('DD.MM.YYYY.') });
                    }
                    else if (daysLeft <= 30) {
                        warningMsg = I18n.t('sdc.esdc.certificate_expires_message', { value: moment(expiresAt).format('DD.MM.YYYY.') });
                    }
                }
            }
            if (sdcType === 'VSDC') {
                expiresAt = (await appStorage.native().getItem(AppStorageKey.sdcCertExpirationDate)) || undefined;
                if (expiresAt) {
                    daysLeft = moment(expiresAt).diff(moment(), 'days');
                    if (daysLeft < 0) {
                        warningMsg = I18n.t('sdc.security_element_file_expired_message', { value: moment(expiresAt).format('DD.MM.YYYY.') });
                    }
                    else if (daysLeft <= 30) {
                        warningMsg = I18n.t('sdc.security_element_file_expires_message', { value: moment(expiresAt).format('DD.MM.YYYY.') });
                    }
                }
            }
        }
        return {
            warningMsg,
            expiresAt,
            daysLeft,
            isExpired: daysLeft !== undefined ? daysLeft < 0 : false
        };
    },
};
export default CertificateService;
//# sourceMappingURL=CertificateService.js.map